import {get} from 'lodash';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/react-hooks';
import {setItem, MAB_PAYLOAD_ITEM} from '../../utils/sessionStorage';
import {SERP_PREVIOUSLY_VIEWED_CAROUSEL} from '../../components/LeadCarouselContainer';

const mabQuery = gql`
    query(
        $componentsReady: [MabComponentType]!
        $campaignFeature: CampaignFeature!
        $clientContext: SerpContext
    ) {
        judgeSerp(
            componentsReady: $componentsReady
            campaignFeature: $campaignFeature
            clientContext: $clientContext
        ) {
            mabEventPayloadJson
            result {
                component
                level
            }
        }
    }
`;

export const storeSessionPayload = ({judgeSerp}) => {
    if (judgeSerp && judgeSerp.mabEventPayloadJson) {
        setItem(MAB_PAYLOAD_ITEM, judgeSerp.mabEventPayloadJson);
    }
};

export const useFetchJudgeSerpData = (
    resultCount,
    isDatedSearch,
    deviceType,
    showRecentlyViewedCarousel = true
) => {
    const componentsReady = [];
    if (showRecentlyViewedCarousel) {
        componentsReady.push(SERP_PREVIOUSLY_VIEWED_CAROUSEL);
    }
    const {data} = useQuery(mabQuery, {
        skip: !resultCount || !componentsReady.length,
        variables: {
            componentsReady,
            campaignFeature: 'SERP_LEAD_COMPONENT',
            clientContext: {
                isDatedSearch,
                resultsSize: resultCount,
                deviceType
            }
        },
        onCompleted: storeSessionPayload
    });

    return get(data, ['judgeSerp'], {});
};
